import request from '@/utils/request'

// 类型表

let TypeApi = {

    /*列表*/
    getList(data, errorback) {
        return request._post('/shop/study.type/index', data, errorback);
    },

    /*添加*/
    add(data, errorback) {
        return request._post('/shop/study.type/add', data, errorback);
    },

    /*删除*/
    del(data, errorback) {
        return request._post('/shop/study.type/del', data, errorback);
    },

    /*编辑*/
    edit(data, errorback) {
        return request._post('/shop/study.type/edit', data, errorback);
    }
}

export default TypeApi;



// WEBPACK FOOTER //
// ./src/api/study/type.js